import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)


export default new Vuex.Store({
  state: {
	  consulting:"023-52999777",		//咨询
	  rescue:"023-52282119",			//救援
	  complain:"023-52125005",		//投诉
	  max:"29211"
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
